import Plyr from "plyr";
import Hls from "hls.js/dist/hls.light.min";

class VideoPlayer {

    protected url;
    protected type;
    protected player;
    protected onEnded = () => {};

    constructor(params) {
        this.url = params.url;
        this.type = typeof params.type !== 'undefined' ? params.type: 'default';
        if (typeof params.onEnded !== 'undefined') {
            this.onEnded = params.onEnded;
        }
    }

    render() {
        if (this.type === 'youtube') {
            let autoplay = $('html').hasClass('bx-touch')
                ? ' allow="autoplay"' : '';
            return `<div class="video-player youtube-player">
                        <div class="plyr__video-embed">
                            <iframe  src="${this.url}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1" allowfullscreen allowtransparency${autoplay}></iframe>
                        </div>
                    </div>`;
        }
        else if (this.type === 'default') {
            return `<div class="video-player">
                        <video controls><source src="${this.url}"></video>
                    </div>`;
        }
        else if (this.type === 'cdn') {
            if ($('html').hasClass('bx-touch')) {
                this.url = this.url + '&autoplay=true&mute=true';
            }
            return `<div class="video-player">
                        <div class="plyr plyr__video-embed">
                            <iframe src="${this.url}" frameBorder="0" scrolling="no" allowfullscreen allowtransparency allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </div>`;
        }
        else if (this.type === 'hls') {
            let muted = ($('html').hasClass('bx-touch')) ? 'muted' : '';

            return `<div class="stream-player">
                        <video playsinline ${muted} autoplay></video>
                    </div>`;
        }
    }


    init() {
        if (this.type === 'youtube') {
            this.player = new Plyr('.video-player.youtube-player > div', {
                autoplay: false,
                controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
                fullscreen: {
                    iosNative: true
                },
            });

            this.player.on('ended', event => {
                this.onEnded()
            });
            return;
        }
        if (this.type === 'default') {
            this.player = new Plyr('.video-player video', {
                debug: false,
                controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
                fullscreen: {
                    iosNative: true
                }
            });


            this.player.on('ended', event => {
                this.onEnded()
            });
            return;
        }

        if (this.type === 'hls') {
            let video = document.querySelector('#modal-announcement video') as any;
           /* if (Hls.isSupported()) {
                var hls = new Hls();
                hls.loadSource(this.url);
                hls.attachMedia(video);
            }  else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = this.url;
            }*/
            this.player = new Plyr(video, {
                debug: false,
                controls: ['play', 'mute', 'volume', 'fullscreen'],
                fullscreen: {
                    iosNative: true
                }
            });
            if (!Hls.isSupported()) {
                video.src = this.url;
            } else {
                const hls = new Hls();
                hls.loadSource(this.url);
                hls.attachMedia(video);
            }
        }
    }

    initPlay() {
        this.init();

        let isTouchDevice = document.querySelector('html').classList.contains('bx-touch')
        if (this.type !== 'cdn' && isTouchDevice !== true) {
            setTimeout(() => {
                this.player.play()
            }, 1000);
        }
    }
}

export default VideoPlayer;
